/**
 * 한국어 번역
 * 
 * 구조:
 * - calendar: 캘린더 관련
 * - reservation: 예약 관련
 * - common: 공통 (버튼, 상태 등)
 * - message: 메시지 관련
 * - error: 에러 메시지
 */

const ko = {
    // 캘린더 관련
    calendar: {
        today: '오늘',
        month: '월',
        week: '주',
        day: '일',
        expandEarlyHours: '0-8시 펼치기',
        collapseEarlyHours: '0-8시 접기',
        normalMode: '일반',
        addMode: '추가',
        offdayMode: '휴무',
        adminMode: '관리',
        limitSettings: '제한설정',
        helpTitle: '모드 설명',
        helpNormal: '일반(NORMAL): 예약을 확인하고 관리하는 기본 모드입니다.',
        helpAdd: '추가(ADD): 새로운 예약을 생성하는 모드입니다.',
        helpOff: '휴무(OFF): 휴무일을 설정하는 모드입니다.',
        blockedDay: '일정추가 금지일입니다.',
        studioUnavailable: '이 날은 스튜디오 이용이 불가능합니다.',
        overlappingLimit: '이미 {limit}개의 이벤트가 있습니다. 최대 {limit}개까지 허용됩니다.',
        concurrentLimitExceeded: '동시일정 제한 초과: 기본 제한 ({limit}개) - 전역 기본 설정',
        modal: {
            restrictedAddTitle: '금지시간 추가',
            restrictedEditTitle: '금지시간 수정',
            eventAddTitle: '일정 추가',
            eventEditTitle: '일정 수정',
            reason: '금지 사유',
            title: '제목',
            startDate: '시작 날짜',
            endDate: '종료 날짜',
            startTime: '시작 시간',
            endTime: '종료 시간',
            allDay: '하루종일',
            fullDayRestriction: '종일 금지',
            timedRestriction: '시간대 금지',
            saving: '저장 중...',
            saveChanges: '변경사항 저장',
            addRestriction: '금지시간 추가',
            addEvent: '일정 추가',
            reasonRequired: '금지 사유를 입력해주세요.',
            titleRequired: '제목을 입력해주세요.',
            startRequired: '시작 시간을 선택해주세요.',
            endRequired: '종료 시간을 선택해주세요.',
            endAfterStart: '종료 시간은 시작 시간보다 늦어야 합니다.',
        },
    },

    // 예약 관련
    reservation: {
        pageTitle: '예약 목록',
        status: '상태',
        type: '무엇',
        client: '고객',
        date: '날짜',
        updated: '수정',
        created: '생성',
        memo: '메모',
        reservationDate: '예약일',
        instagram: '인스타그램',
        customerName: '고객명',
        deposit: '선금',
        finalPrice: '최종가격',
        reservationType: '예약타입',
        email: '이메일',
        phone: '전화번호',
        minPrice: '최소 가격',
        maxPrice: '최대 가격',
        budget: '예산',
        description: '설명',
        preferredPart: '선호 부위',
        preferredDates: '선호 날짜',
        referenceImages: '참조 이미지',
        flashImage: '이미지',
        category: '카테고리',
        artist: '아티스트',

        // 상태
        statusLabels: {
            requested: '요청됨',
            in_progress: '진행중',
            pending: '대기중',
            confirmed: '확정됨',
            deposit_paid: '선금완료',
            deposit_confirmed: '선금확인',
            completed: '완료',
            cancelled: '취소됨',
        },
    },

    // 공통
    common: {
        loading: '로딩 중...',
        save: '저장',
        cancel: '취소',
        delete: '삭제',
        close: '닫기',
        confirm: '확인',
        edit: '수정',
        add: '추가',
        search: '검색',
        filter: '필터',
        yes: '예',
        no: '아니오',
        noData: '데이터가 없습니다',
        enterMemo: '메모를 입력하세요...',
    },

    // 에러 메시지
    error: {
        eventUpdateError: '이벤트 수정 중 오류가 발생했습니다.',
        startEndTimeRequired: '시작 시간과 종료 시간이 필요합니다.',
        endTimeAfterStart: '종료 시간은 시작 시간보다 늦어야 합니다.',
        userInfoError: '사용자 정보를 불러올 수 없습니다. 페이지를 새로고침해주세요.',
        dayOffDeleteError: 'DayOff 삭제에 실패했습니다.',
        dayOffAddError: 'DayOff 등록에 실패했습니다.',
        blockDeleteError: '금지기간 삭제에 실패했습니다.',
        blockAddError: '금지기간 등록에 실패했습니다.',
        unknownError: '알 수 없는 오류가 발생했습니다.',
        depositConfirmFailed: '선금확인 실패: ',
        depositCancelFailed: '선금철회 실패: ',
        depositProcessError: '선금 처리 중 오류가 발생했습니다: ',
        deleteConfirm: '정말 삭제하시겠습니까?',
        deleteSuccess: '삭제되었습니다',
    },

    // 성공 메시지
    success: {
        eventUpdatedSuccess: '이벤트가 성공적으로 수정되었습니다.',
        blockRemoved: '금지기간이 해제되었습니다.',
        blockAdded: '금지기간이 설정되었습니다.',
    },

    // 메시지/DM 관련
    message: {
        noPermission: '내 일정이 아니라서 권한이 없습니다.',
        updatingEvent: '수정 중...',
        noConnectedEvent: '연결된 일정 없음',
    },

    // 날씨 위젯
    weather: {
        days: ['일', '월', '화', '수', '목', '금', '토'],
    },

    // 예약 요약
    summary: {
        thisMonth: '이번달',
        thisWeek: '이번주',
        today: '오늘',
        count: '건',
        next: '다음',
        pendingDeposit: '선금확인 대기',
        noName: '이름 없음',
    },

    // 메인페이지 공지
    announcement: {
        title: '공지',
        write: '공지 작성',
        edit: '수정',
        clear: '공지 내리기',
        clearing: '내리는 중...',
        contentLabel: '공지 내용',
        empty: '현재 게시된 공지가 없습니다.',
        save: '저장',
        saving: '저장 중...',
        cancel: '취소',
        clearConfirm: '현재 공지를 내리시겠습니까?',
        contentRequired: '공지 내용을 입력해주세요.',
        contentTooLong: '공지는 {max}자 이내로 작성해주세요.',
        loadError: '공지를 불러오지 못했습니다.',
        saveError: '공지를 저장하지 못했습니다.',
        clearError: '공지를 내리지 못했습니다.',
    },

    // 플래시북
    flashbook: {
        title: 'FLASH BOOK',
        newPlanche: '+ NEW',
        empty: '플럹슈가 없습니다',
        emptyHint: '새 플럹수를 만들어보세요',
        createError: '생성 실패',
        available: '판매중',
        sold: '판매완료',
        replaceImage: '교체',
        download: '다운',
        downloadAll: '전체 플래시 다운로드',
        downloadAllError: '플래시 전체 다운로드에 실패했습니다.',
        crop: '크롭',
        flashName: '이름',
        size: '사이즈',
        showInfo: '정보',
        visible: 'ON',
        hidden: 'OFF',
        downloadOriginal: '원본',
        downloadCanvas: '캔버스',
        deleteFailed: '삭제 실패',
        deleteConfirm: '{number} 삭제?',
        nameSaved: '이름 저장됨',
        sizeSaved: '사이즈 저장됨',
        soldStyle: 'SOLD',
        titleStyle: 'TITLE',
        bgStyle: 'BG',
    },

    // Stock Management
    stock: {
        title: '재고관리',
        add: '추가',
        save: '저장',
        cancel: '취소',
        delete: '삭제',
        name: '품명',
        quantity: '수량',
        category: '카테고리',
        image: '이미지 URL',
        supplier: '공급업체',
        priceHT: '가격(HT)',
        tvaRate: 'TVA %',
        minStock: '최소재고',
        noData: '항목 없음',
        noAccess: '접근 권한 없음',
        lowStock: '부족',
        all: '전체',
        uncategorized: '미분류',
        searchPlaceholder: '검색...',
        confirmDelete: '이 항목을 삭제하시겠습니까?',
        addItem: '추가',
        editItem: '수정',
        loadError: '로드 실패',
        saveError: '저장 실패',
        deleteError: '삭제 실패',
        categories: '카테고리',
        newCategory: '새 카테고리...',
    },
};

export default ko;
